import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import EmployeeCornerSidebar from "./EmployeeCornerSidebar";
import BackButton from "../../GlobalManagement/Pages/BackButton";

const formatDDMMYYYY = (dateStr) => {
  if (!dateStr) return "-";
  let d;
  if (dateStr.includes("-") && dateStr.split("-")[0].length === 2) {
    const [day, month, year] = dateStr.split("-");
    d = new Date(year, month - 1, day);
  } else {
    d = new Date(dateStr);
  }
  if (isNaN(d)) return "-";
  return `${String(d.getDate()).padStart(2, "0")}-${String(
    d.getMonth() + 1
  ).padStart(2, "0")}-${d.getFullYear()}`;
};

const RMAttendanceRequestApproval = () => {
  const [requestList, setRequestList] = useState([]);
  const [loading, setLoading] = useState(true);

  const loggedInUser = JSON.parse(localStorage.getItem("employeeUser")) || {};
  const loggedInEmployeeUserId = loggedInUser?.employeeUserId;

  useEffect(() => {
    if (loggedInEmployeeUserId) fetchRequests();
  }, [loggedInEmployeeUserId]);

  const fetchRequests = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `/api/attendance-approval/manager/${loggedInEmployeeUserId}`
      );
      setRequestList(res.data || []);
    } catch (error) {
      toast.error("Failed to load attendance requests");
    } finally {
      setLoading(false);
    }
  };

  const updateRequestStatus = async (id, status) => {
    try {
      await axios.put(
        `/api/attendance-approval/${id}/status`,
        { 
          status, 
          loggedInUserId: loggedInEmployeeUserId 
        }
      );
      toast.success(`Attendance request ${status}`);
      fetchRequests();
    } catch (error) {
      toast.error("Failed to update status");
    }
  };

  return (
    <div className="flex min-h-screen flex-col md:flex-row">
      <EmployeeCornerSidebar />

      <div className="flex-1 overflow-y-auto p-1 sm:p-1">
        <div className="bg-white shadow-md rounded-md p-2 sm:p-1">
          
          <div className="bg-dorika-blueLight border border-blue-300 rounded-lg shadow-md p-1 mb-1 sm:mb-1 flex flex-row justify-between items-center gap-2">
            <h2 className="text-sm sm:text-xl font-bold text-dorika-blue whitespace-nowrap">
              Attendance Request Approval Panel
            </h2>
            <div className="flex shrink-0">
              <BackButton />
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full table-auto border border-dorika-blue text-xs sm:text-sm">
              <thead className="bg-dorika-blue text-white">
                <tr>
                  <th className="border border-dorika-blue px-1 py-[1px] whitespace-nowrap">S.No</th>
                  <th className="border border-dorika-blue px-1 py-[1px] whitespace-nowrap">Employee ID</th>
                  <th className="border border-dorika-blue px-1 py-[1px] whitespace-nowrap">Employee Name</th>
                  <th className="border border-dorika-blue px-1 py-[1px] whitespace-nowrap">Applied On</th>
                  <th className="border border-dorika-blue px-1 py-[1px] whitespace-nowrap">Month / Year</th>
                  <th className="border border-dorika-blue px-1 py-[1px] whitespace-nowrap">Absent Dates</th>
                  <th className="border border-dorika-blue px-1 py-[1px] whitespace-nowrap">Reason</th>
                  <th className="border border-dorika-blue px-1 py-[1px] whitespace-nowrap">Statuses</th>
                  <th className="border border-dorika-blue px-1 py-[1px] whitespace-nowrap">Action</th>
                </tr>
              </thead>

              <tbody className="text-center">
                {requestList.length > 0 ? (
                  requestList.map((req, index) => {
                    const myDecision = req.reportingManagerStatus;

                    // Disable Approve if already Approved; Disable Reject if already Rejected
                    const disableApprove = myDecision === "Approved";
                    const disableReject = myDecision === "Rejected";

                    return (
                      <tr key={req._id} className="hover:bg-dorika-blueLight transition h-8">
                        <td className="border border-dorika-blue px-1 py-[1px]">{index + 1}</td>
                        <td className="border border-dorika-blue px-1 py-[1px]">{req.employeeId}</td>
                        <td className="border border-dorika-blue px-1 py-[1px]">{req.name}</td>
                        <td className="border border-dorika-blue px-1 py-[1px]">{formatDDMMYYYY(req.applicationDate)}</td>
                        <td className="border border-dorika-blue px-1 py-[1px]">{req.monthYear}</td>
                        <td className="border border-dorika-blue px-1 py-[1px]">
                          <div className="flex flex-wrap gap-1 justify-center">
                            {req.absentDates?.map((d) => (
                              <span key={d} className="px-1.5 py-0.5 bg-sky-100 text-sky-800 rounded text-[10px] font-bold">
                                {formatDDMMYYYY(d)}
                              </span>
                            ))}
                          </div>
                        </td>
                        <td className="border border-dorika-blue px-1 py-[1px]">{req.reason}</td>

                        <td className="border border-dorika-blue px-1 text-left">
                          <div className="flex flex-col">
                            <span className="text-[10px]">
                              RM: <b className={
                                req.reportingManagerStatus === 'Approved' ? 'text-green-600' : 
                                req.reportingManagerStatus === 'Rejected' ? 'text-red-600' : 'text-orange-500'
                              }>
                                {req.reportingManagerStatus} {req.reportingManagerStatusDate ? `(${req.reportingManagerStatusDate} || ${req.reportingManagerStatusTime || ''})` : ''}
                              </b>
                            </span>
                            <span className="text-[10px]">
                              HR: <b className={
                                req.HRStatus === 'Approved' ? 'text-green-600' : 
                                req.HRStatus === 'Rejected' ? 'text-red-600' : 'text-orange-500'
                              }>
                                {req.HRStatus}
                              </b>
                            </span>
                            <span className="text-[10px]">
                              Final: <b className={
                                req.FinalStatus === 'Approved' ? 'text-green-600' : 
                                req.FinalStatus === 'Rejected' ? 'text-red-600' : 'text-orange-500'
                              }>
                                {req.FinalStatus}
                              </b>
                            </span>
                          </div>
                        </td>

                        <td className="border border-dorika-blue px-1 py-[1px]">
                          <div className="flex flex-col items-center gap-1">
                            <div className="flex justify-center gap-1">
                              <button
                                disabled={disableApprove}
                                onClick={() => updateRequestStatus(req._id, "Approved")}
                                className={`px-2 py-[1px] rounded text-[10px] text-white transition ${
                                  disableApprove ? "bg-gray-400 cursor-not-allowed" : "bg-green-600 hover:bg-green-700"
                                }`}
                              >
                                Approve
                              </button>
                              <button
                                disabled={disableReject}
                                onClick={() => updateRequestStatus(req._id, "Rejected")}
                                className={`px-2 py-[1px] rounded text-[10px] text-white transition ${
                                  disableReject ? "bg-gray-400 cursor-not-allowed" : "bg-red-600 hover:bg-red-700"
                                }`}
                              >
                                Reject
                              </button>
                            </div>

                            {myDecision !== "Pending" && (
                              <span className={`text-[9px] font-bold uppercase ${
                                myDecision === 'Rejected' ? 'text-red-600' : 'text-green-600'
                              }`}>
                                You {myDecision}
                              </span>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center py-4 text-gray-500">No attendance requests found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  );
};

export default RMAttendanceRequestApproval;